module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-runtime/regenerator/index.js
// module id = 374
// module chunks = 29